import React, {useEffect} from 'react';
import {
  Image,
  ImageBackground,
  ScrollView,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';
import {createStyles} from '../../../utils/createStyles';
import {ossImg} from '../../../utils/oss';
import {Avatar} from '@rneui/themed';
import {useAppSelector} from '../../../store/hooks';
import {getUserInfo, saveUserInfo, selectUserInfo} from '../../../store/user';
import {staticDictionary} from '../../../utils/dictionary';
import Icon from 'react-native-vector-icons/Ionicons';
import {ActivateRedeemCode} from '../../../API/user';
import Toast from 'react-native-toast-message';
import {useNavigation} from '@react-navigation/native';
import {useAppDispatch} from '../../../store/hooks';
import {logout, getToken} from '../../../request/token';

export default function CDK() {
  const navigator = useNavigation();
  const dispatch = useAppDispatch();
  const userInfo = useAppSelector(selectUserInfo);
  const [CDK, setCDK] = React.useState('');
  useEffect(() => {
    const fetchUserInfo = async () => {
      if ((await getToken()) && !userInfo.name) {
        console.log('userInfo', userInfo);
        await dispatch(getUserInfo()).unwrap();
      }
    };

    fetchUserInfo();
  }, [userInfo, dispatch]);
  const activate = () => {
    if (!CDK) {
      return Toast.show({
        type: 'error',
        text1: '请输入兑换码',
      });
    }

    ActivateRedeemCode({
      redeemCode: CDK,
      mobile: userInfo.mobile as string,
    }).then(r => {
      if (r.status === 200) {
        dispatch(saveUserInfo(r.data));
        Toast.show({
          type: 'success',
          text1: '兑换成功',
        });
        setTimeout(() => {
          navigator.replace('ChatGPTAssist');
        }, 1000);
      } else if (r.status === 201) {
        Toast.show({
          type: 'error',
          text1: r.msg,
        });
      }
    });
  };
  const gradeName =
    staticDictionary.userGradeList.find(
      item => item.id === userInfo?.curriculumSetup?.xkwGradeId,
    )?.name || '';
  const rights = [
    {
      title: '爱宝伴聊',
      message:
        '超强人工智能AI精灵爱宝，无所不知，无所不晓，通过与孩子的实时语音互动交流，为孩子提供学习指导、生活陪伴等全方位帮助，是孩子的好伙伴、好帮手。',
      avatar:
        'https://media.oss.leziedu.com/webapp/classroom/userCenter/%E7%BB%84%201904.png',
    },
    {
      title: 'AI伴学师',
      message:
        '针对孩子的学习能力、素质培养、心理健康等多角度推出定向AI教师，通过AI教师实时语音互动的方式，对孩子进行启发式、个性化1v1辅导，提升孩子学习能力与综合素养。',
      avatar:
        'https://media.oss.leziedu.com/webapp/classroom/userCenter/%E7%BB%84%201905.png',
    },
    {
      title: 'AI同步测',
      message:
        '提供优质、海量练习资源，可根据孩子的学习进度、知识点掌握情况，个性化生成练习题目与配套讲解，让孩子完成同步练习、复习巩固、查漏补缺。',
      avatar:
        'https://media.oss.leziedu.com/webapp/classroom/userCenter/%E7%BB%84%201906.png',
    },
    {
      title: 'AI备考',
      message:
        '提供名校真题、阶段测评、专题训练等最新、优质的试卷资源及配套讲解，为孩子巩固练习、诊断测评等不同场景的测评需求提供全面、丰富的试卷资源。',
      avatar:
        'https://media.oss.leziedu.com/webapp/classroom/userCenter/%E7%BB%84%201907.png',
    },
  ];
  return (
    <ImageBackground
      style={styles.flex1}
      source={require('../../../assets/images/userCenter/bg.png')}>
      <View style={styles.CDKContent}>
        <View style={styles.rightTime}>
          <Image
            style={styles.timeImg}
            source={{
              uri: 'https://media.oss.leziedu.com/webapp/classroom/userCenter/%E5%AE%B9%E5%99%A8%20(2).png',
            }}
          />
          <Text style={styles.timeText}>
            {userInfo.webExpireTime
              ? `权益有效期：${userInfo.webExpireTime}`
              : '暂无权益'}
          </Text>
        </View>
        <View style={styles.viewTop}>
          <Avatar
            size={70}
            rounded
            imageProps={{
              resizeMode: 'cover',
            }}
            avatarStyle={{width: '100%', height: '100%'}}
            source={
              userInfo.avatar
                ? {uri: ossImg(userInfo.avatar)}
                : require('../../../assets/images/av.png')
            }
          />
          <View style={styles.userInfo}>
            <View style={styles.userName}>
              <Text style={styles.nameText}>{userInfo.name}</Text>
              <Icon
                name={userInfo.gender === 2 ? 'female-outline' : 'male-outline'}
                size={20}
                color={'#333'}
              />
            </View>
            <View style={styles.userMobile}>
              <Text style={styles.mobileText}>{userInfo.mobile}</Text>
              <View style={styles.grade}>
                <Text style={styles.gradeText}>{gradeName}</Text>
              </View>
            </View>
          </View>
        </View>
        <Text style={styles.title}>权益兑换</Text>
        <Text style={styles.subtitle}>请输入兑换码兑换权益</Text>
        <TextInput style={styles.input} onChangeText={v => setCDK(v)} />
        <TouchableOpacity
          onPress={activate}
          style={styles.button}
          activeOpacity={0.6}>
          <Text style={styles.buttonText}>立即兑换</Text>
        </TouchableOpacity>
        <TouchableOpacity
          activeOpacity={0.7}
          onPress={() => navigator.navigate('FuWuDocument')}>
          <Text style={styles.footerText}>《用户服务协议》</Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.logout}
          activeOpacity={0.7}
          onPress={() => {
            logout();
          }}>
          <Text style={styles.footerText}>退出登录</Text>
        </TouchableOpacity>
      </View>
      <View style={styles.CDKRights}>
        <View style={styles.itemHeader}>
          <View style={styles.line} />
          <Text style={styles.filterHeaderText}>权益介绍</Text>
        </View>
        <ScrollView>
          {rights.map(item => (
            <View style={styles.rightItem}>
              <Image
                source={{uri: item.avatar}} // 替换为实际的图片地址
                style={styles.rightAvatar}
              />
              <View style={styles.rightContent}>
                <Text style={styles.rightTitle}>{item.title}</Text>
                <Text style={styles.rightMessage}>{item.message}</Text>
              </View>
            </View>
          ))}
        </ScrollView>
      </View>
    </ImageBackground>
  );
}

const styles = createStyles({
  flex1: {
    flex: 1,
    flexDirection: 'row',
  },
  CDKContent: {
    position: 'relative',
    flex: 933,
    flexDirection: 'column',
  },
  rightTime: {
    position: 'absolute',
    top: '0.8rem',
    right: '1.1rem',
    flexDirection: 'row',
    alignItems: 'center',
  },
  timeImg: {
    width: '1.25rem',
    height: '1.25rem',
    marginRight: '0.5rem',
  },
  timeText: {
    fontSize: '1.2rem',
    color: '#333333',
  },
  viewTop: {
    position: 'relative',
    paddingLeft: '4.3rem',
    height: '28.4%',
    flexDirection: 'row',
    alignItems: 'center',
  },
  userInfo: {
    marginLeft: '1.3rem',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  userName: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  nameText: {
    marginRight: '0.8rem',
    fontSize: '1.9rem',
    color: '#333333',
  },
  userMobile: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  mobileText: {
    color: '#333333',
    fontSize: '1.6rem',
  },
  grade: {
    marginLeft: '0.8rem',
    height: '1.8rem',
    paddingHorizontal: '0.7rem',
    paddingVertical: '0.7rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '1.8rem',
    backgroundColor: '#8E8CFC',
  },
  gradeText: {
    fontSize: '1.1rem',
    color: '#fff',
  },
  title: {
    alignSelf: 'center',
    fontSize: '2.1rem',
    fontWeight: 'bold',
    marginBottom: '1rem',
    color: '#7065E7',
  },
  subtitle: {
    alignSelf: 'center',
    fontSize: '1.4rem',
    color: '#3D3D3D',
    marginBottom: '2rem',
  },
  input: {
    alignSelf: 'center',
    height: '5rem',
    width: '80%',
    color: '#3D3D3D',
    borderRadius: '1rem',
    backgroundColor: '#fff',
    textAlign: 'center',
    fontSize: '2rem',
  },
  button: {
    alignSelf: 'center',
    height: '4rem',
    width: '20rem',
    backgroundColor: '#7A42F4',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '2rem',
    marginTop: '10rem',
    marginBottom: '1.2rem',
  },
  buttonText: {
    color: '#FFFFFF',
    fontSize: '1.6rem',
  },
  footerText: {
    alignSelf: 'center',
    color: '#007AFF',
    fontSize: 14,
  },
  CDKRights: {
    flex: 1075,
    paddingLeft: '3.15rem',
    paddingRight: '2.5rem',
    backgroundColor: '#fff',
  },
  itemHeader: {
    marginTop: '1.5rem',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '0.7rem',
  },
  line: {
    width: '0.4rem',
    height: '1.35rem',
    borderRadius: '0.4rem',
    marginRight: '0.7rem',
    backgroundColor: '#695DF3',
  },
  filterHeaderText: {
    fontSize: '1.9rem',
    fontWeight: 'bold',
    color: '#3D3D3D',
  },
  rightItem: {
    marginTop: '1rem',
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: '1.4rem',
    borderRadius: '1.1rem',
    backgroundColor: '#F3F7FF',
  },
  rightAvatar: {
    width: '8rem', // 头像的宽度
    height: '8rem', // 头像的高度
    marginRight: '2.7rem', // 头像与文本内容的间距
    marginLeft: '2.7rem', // 头像与左边框的间距
  },
  rightContent: {
    flex: 1,
    height: '100%',
  },
  rightTitle: {
    fontWeight: 'bold',
    fontSize: '1.8rem',
    color: '#3D3D3D',
    marginBottom: '0.4rem', // 标题与消息文本的间距
  },
  rightMessage: {
    fontSize: '1.15rem',
    color: '#555555',
  },
  logout: {
    marginTop: '1rem',
    alignSelf: 'center',
  },
});
